import script from "./InPersonVirtualTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./InPersonVirtualTemplate.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__